import { css } from '@emotion/react'

import colors from './colors'
import { typo } from './cssStyles'

const { gray } = colors

const resetCSS = css`
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: inherit;
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  html, body {
    margin: 0;
    padding: 0;
    border: 0;
  }
  body {
    overflow: auto;
    color: ${gray.$900};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${typo.body02};
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  li,
  ol {
    list-style: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  [type='text'] {
    padding: 0;
  }

  button {
    color: ${gray.$900};
    ${typo.body02};
    &:disabled {
      cursor: default;
    }
  }

  svg {
    display: block;
  }
  input {
    font-size: 14px;
  }
  textarea:focus {
    outline: none;
  }

  img {
    image-rendering: -webkit-optimize-contrast;
  }
`

export default resetCSS
